import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Messages } from 'src/app/constants/messages';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-ota-modal',
  templateUrl: './ota-modal.component.html',
  styleUrls: ['./ota-modal.component.css']
})
export class OtaModalComponent implements OnInit, OnDestroy { 

  @ViewChild("values", { static: false }) valueRef: ElementRef | undefined;

  @Input() otaData: any;
  @Input() otaAdd: any;
  @Input() otaView: any;
  @Input() otaEdit: any;

  otaForm: FormGroup;
  formSubmitted: boolean = false;
  appList: any = [];
  appTypeList: any = [];
  deviceModels: any = [];
  fileLoader: boolean = false;
  fileValidationError: any = null;
  fileURL: any = null;
  buttonText: any = null;
  fileInfo: any;
  modalClose: boolean = false;
  errorMessage: any = 'File is required';
  errorMessg: any = null;
  checkApiCall: boolean = false;
  myAngularxQrCode: any = null;
  errorMessages: any = null;

  private _loading: boolean = false;
  private _sasUrl: any = null;
  private _fileType: any = null;
  private _fileExist: any = false;
  private _enableSubmit: boolean = false;
  private _fileError: any = null;
  private _message: any = null;
  private _afterClosedSubscription: Subscription;
  private _afterClosedDeleteFileSubscription: Subscription;
  private _saveOtaAppSubscription: Subscription;
  private _saveOtaAppEditApkSubscription: Subscription;
  private _uploadOtaFileSubscription: Subscription;

  
  constructor(
    private _activeModal: NgbActiveModal,
    private _fb: FormBuilder,
    private _service: ServicecallService,
    private _cd: ChangeDetectorRef,
    private _dialog: MatDialog
  ) {
    this.otaForm = this._fb.group({
      app: ['', [Validators.required]],
      deviceModel: ['', [Validators.required]],
      appType: ['', [Validators.required]],
      stableVersion: ['', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      latestVersion: ['', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      fileName: ['', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      fileSize: ['', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      url: ['', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]]
    });
  }

  ngOnInit(): void {
    this.otaForm = this._fb.group({
      app: [this.otaData?.app ? this.otaData?.app : '', [Validators.required]],
      deviceModel: [this.otaData?.app ? this.otaData?.app : '', [Validators.required]],
      appType: [this.otaData?.app ? this.otaData?.app : '', [Validators.required]],
      stableVersion: [this.otaData?.app ? this.otaData?.app : '', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      latestVersion: [this.otaData?.app ? this.otaData?.app : '', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      fileName: [this.otaData?.app ? this.otaData?.app : '', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      fileSize: [this.otaData?.app ? this.otaData?.app : '', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      url: [this.otaData?.app ? this.otaData?.app : '', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]]
    });
    this._loadConfigurationModalData();
  }
  ngOnDestroy(): void {
    this._afterClosedSubscription?.unsubscribe();
    this._afterClosedDeleteFileSubscription?.unsubscribe();  
    this._saveOtaAppSubscription?.unsubscribe();  
    this._saveOtaAppEditApkSubscription?.unsubscribe();  
    this._uploadOtaFileSubscription?.unsubscribe();  
    
  }
  closeModal() {
    if (this.otaForm.dirty) {
      let dialogRef = this._dialog.open(AlertDialogComponent, {
        data: { msg: Messages.UNSAVED_CHANGES, type: null },
        disableClose: true
      });
      this._afterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this._activeModal.close();
        }
      });
    }
    else {
      this._activeModal.close();
    }
  }
  changeDevice(event: {
    isUserInput: any;
    source: { value: any; selected: any };
  }) {
    if (event.isUserInput) {
      if (event.source.selected === true) {
        const value = event.source.value;
        let f = this.appList.find((x: any) => x.app === value);
        this.deviceModels = f['deviceModel'];
        this.otaForm.value.deviceModel = f['deviceModel'][0];
      }
    }
  }
  onSubmit() {
    this.formSubmitted = true;
    if (this.otaForm.invalid) {
      return;
    }

    if (this.otaEdit && this.fileURL != null) {
      if (this._fileType === this.otaForm.value.appType) {
        this.fileValidationError = null;
        this._editApk();
      } else {
        this.fileValidationError = 'The file should be of ' + '.' + this.otaForm.value.appType + ' format'

      }
    } else if (this.fileURL != null) {
      if (this._fileType === this.otaForm.value.appType) {
        this.fileValidationError = null;
        this._addApk();
      } else {
        this.fileValidationError = 'The file should be of ' + '.' + this.otaForm.value.appType + ' format'
      }
    }
  }
  deleteFile() {
    this._loading= true;
    let relativePath: any;
    let recordId: any;
    if (this._sasUrl == null && this.otaEdit) {
      let dialogRef = this._dialog.open(AlertDialogComponent, {
        data: { msg: 'Are you sure you want to permanently delete this file?', type: null },
        disableClose: true
      });
      this._afterClosedDeleteFileSubscription = dialogRef.afterClosed().subscribe(result => {
        if (result) {
          relativePath = this.fileURL.split("?")[0].split("/").slice(-3).join('/');
          recordId = this.otaData['_id'];
          if (typeof (this.fileInfo) === 'string') {
            if (this._sasUrl == null) {
              relativePath = this.otaData?.url?.split("?")[0].split("/").slice(-3).join('/');
              recordId = this.otaData?._id;
            }
            else {
              relativePath = this._sasUrl.split("?")[0].split("/").slice(-3).join('/');
              recordId = null;
            }
          }
          else {
            this.otaForm.value.url = null;
            this.fileURL = null
          }
          this._fileUpload(relativePath, null, recordId);
          this.errorMessage = 'File is required'
          this.checkApiCall = false;
          this._loading= true;
          this.otaForm.patchValue({ fileSize: null, fileName: null, url: null });
        }
      });
      // let r = confirm("Are you sure you want to permanently delete this apk?");
      // if (r) {
      //   relativePath = this.fileURL.split("?")[0].split("/").pop();
      //   recordId = this.otaEdit['_id'];
      //   this.fileUpload(relativePath, null, recordId);
      //   this.errorMessage = 'File is required'
      //   this.checkApiCall = false;
      //   this._loading= true;
      // }
    } else {
      relativePath = this._sasUrl.split("?")[0].split("/").slice(-3).join('/');
      this._fileUpload(relativePath, null, recordId);
      this.errorMessage = 'File is required'
      this.checkApiCall = false;
    }
  }

  onFileSelect(event: any) {
    this.buttonText = 'Upload File'
    this._fileType = null;
    this.fileValidationError = null;
    this._fileError = null;
    this._sasUrl = null
    let file: File;
    let reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    file = event.target.files[0];
    if (file) {
      this.otaForm.value.fileSize = this._formatBytes(file.size)
      this.otaForm.value.fileName = file.name;
      this.otaForm.patchValue({ fileSize: this._formatBytes(file.size), fileName: file.name });
    }
    this._fileType = file.name.split(".").pop()
    if (file.name.split(".").pop() === this.otaForm.value.appType) {
      reader.onload = () => {
        this.fileURL = reader.result;
      };
      this.fileInfo = file.name + " " + this._formatBytes(file.size)
      this._fileUpload(null, file, null)
    } else {
      this.fileValidationError = 'The file should be of ' + '.' + this.otaForm.value.appType + ' format'
    }
    this._cd.markForCheck();
  }
  downloadFile() {
    const link = document.createElement('a');
    link.setAttribute('href', this.otaData.url);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
  get formValues() {
    return this.otaForm.controls;
  }

  private _loadConfigurationModalData() {
    this.appList = this._service.getConfiguration('appsAndModels') ? this._service.getConfiguration('appsAndModels').appsAndModels : [];
    this.appTypeList = this._service.getConfiguration('appType') ? this._service.getConfiguration('appType').appType : [];
    if (this.otaData) {
      this.deviceModels = this.appList.find((x: any) => x.app == this.otaData.appName)?.deviceModel;
      this._patchValues();
    }
    if (this.otaEdit) {
      if (this.otaForm.value.url) {
        this.buttonText = 'Delete File'
        this.checkApiCall = true;
        this.fileURL = this.otaForm.value.url;
        this.fileInfo = this.otaForm.value['fileName'] + ' ' + this.otaForm.value['fileSize'];
        this._fileType = this.otaForm.value['fileName'].split(".").pop();
      } else {
        this.buttonText = 'Upload File'
      }
      this.deviceModels = this.appList.find((x: any) => x.app == this.otaForm.value.app)?.deviceModel;
    }
    else if (this.otaView) {
      if (this.otaForm.value.url) {
        this.fileURL = this.otaForm.value.url;
        this.fileInfo = this.otaForm.value['fileName'] + ' ' + this.otaForm.value['fileSize'];
        this.myAngularxQrCode = this.otaForm.value.url;
      }
      this.deviceModels = this.appList.find((x: any) => x.app == this.otaForm.value.app)?.deviceModel;
      this.otaForm.disable();
    } else {
      this.buttonText = 'Upload File';
      this.deviceModels = this.appList[0]['deviceModel']
    }
    this._defaultFieldValues();
  }

  //   this._loading= true;
  //   this._service.configurationsInfo(this.attributes).subscribe((results: any) => {
  //     this._loading= false;
  //     if (results['status']) {
  //       this.appList.length = 0;
  //       let data: any = results['response']
  //       data.forEach((element: any) => {
  //         if (element['attribute'] === "appsAndModels") {
  //           this.appList = element['values']['appsAndModels'];
  //         }
  //         if (element['attribute'] === "appType") {
  //           this.appTypeList = element['values']['appType'];
  //         }
  //       });
  //     }
  //     if (this.otaData) {
  //       this.deviceModels = this.appList.find((x: any) => x.app == this.otaData.appName)?.deviceModel;
  //       this.patchValues();
  //     }
  //     if (this.otaEdit) {
  //       if (this.otaForm.value.url) {
  //         this.buttonText = 'Delete File'
  //         this.checkApiCall = true;
  //         this.fileURL = this.otaForm.value.url;
  //         this.fileInfo = this.otaForm.value['fileName'] + ' ' + this.otaForm.value['fileSize'];
  //         this.fileType = this.otaForm.value['fileName'].split(".").pop();
  //       } else {
  //         this.buttonText = 'Upload File'
  //       }
  //       this.deviceModels = this.appList.find((x: any) => x.app == this.otaForm.value.app)?.deviceModel;
  //     }
  //     else if (this.otaView) {
  //       if (this.otaForm.value.url) {
  //         this.fileURL = this.otaForm.value.url;
  //         this.fileInfo = this.otaForm.value['fileName'] + ' ' + this.otaForm.value['fileSize'];
  //         this.myAngularxQrCode = this.otaForm.value.url;
  //       }
  //       this.deviceModels = this.appList.find((x: any) => x.app == this.otaForm.value.app)?.deviceModel;
  //       this.otaForm.disable();
  //     } else {
  //       this.buttonText = 'Upload File';
  //       this.deviceModels = this.appList[0]['deviceModel']
  //     }
  //     this.defaultFieldValues();
  //   });
  // }

  private _defaultFieldValues() {
    if (!this.otaForm.value.appType || this.otaForm.value.appType === "") {
      this.otaForm.controls['appType'].setValue(this.appTypeList[0] ? this.appTypeList[0]['value'] : '');
    }
    if (!this.otaForm.value.app || this.otaForm.value.app === "") {
      this.otaForm.controls['app'].setValue(this.appList[0] ? this.appList[0]['app'] : '');
    }
    if (!this.otaForm.value.deviceModel || this.otaForm.value.deviceModel === "") {
      this.otaForm.controls['deviceModel'].setValue(this.appList[0] ? this.appList[0]['deviceModel'] ?
        this.appList[0]['deviceModel'][0] : '' : '');
    }
  }
 
  private _patchValues() {
    if (this.otaAdd) {
      this.otaForm.patchValue({ app: this.otaForm.value.app, deviceModel: this.otaForm.value.deviceModel, appType: this.otaForm.value.appType, stableVersion: this.otaForm.value.stableVersion, latestVersion: this.otaForm.value.latestVersion, fileName: this.otaForm.value.fileName, fileSize: this.otaForm.value.fileSize, url: this.otaForm.value.url });
    } else {
      this.otaForm.patchValue({
        app: this.otaData.appName, deviceModel: this.otaData.deviceModel, appType: this.otaData.appType, stableVersion: this.otaData.stableVersion, latestVersion: this.otaData.latestVersion, fileName: this.otaData.fileName, fileSize: this.otaData.fileSize, url: this.otaData.url
      });
    }
  }

  
  private _addApk() {
    this.errorMessages = null;
    let user = localStorage.getItem('name')
    if (user === 'Guest User') {
      user = localStorage.getItem('email')
    }
    else {
      user = localStorage.getItem('name')
    }
    let otaAppDetails: any;
    otaAppDetails = {
      appType: this.otaForm.value.appType,
      app: this.otaForm.value.app,
      deviceModel: this.otaForm.value.deviceModel,
      stableVersion: this.otaForm.value.stableVersion,
      latestVersion: this.otaForm.value.latestVersion,
      url: this.otaForm.value.url,
      fileName: this.otaForm.value.fileName,
      fileSize: this.otaForm.value.fileSize,
      userName: user
    }
    this._loading= true;
    this._saveOtaAppSubscription = this._service.saveOtaApp('add', otaAppDetails).subscribe((res: any) => {
      this._loading= false;
      if (res['status']) {
        if (res['response']) {
          this._service.toasterService({ type: 'success', msg: res['response']['message'] });
          this._message = null;
          this._activeModal.close(true);
        }
        else {
          this.errorMessage = res['response']['message'] + ' - ' + res['response']['error'];
          // this._service.toasterService({ type: 'error', msg: res['response']['message'] });
          this._message = res['response']['message'];
        }
      }
      else {
        this.errorMessage = res['response']['message'] + ' - ' + res['response']['error'];
        // this._service.toasterService({ type: 'error', msg: res['response']['message'] });
        this._message = res['response']['message'];
      }
    })
  }

  private _editApk() {
    this.errorMessages = null;
    let user = localStorage.getItem('name')
    if (user === 'Guest User') {
      user = localStorage.getItem('email')
    }
    else {
      user = localStorage.getItem('name')
    }
    this.checkApiCall = true;
    let otaAppDetails: any;

    otaAppDetails = {
      stableVersion: this.otaForm.value.stableVersion,
      latestVersion: this.otaForm.value.latestVersion,
      url: this.otaForm.value.url,
      fileName: this.otaForm.value.fileName,
      fileSize: this.otaForm.value.fileSize,
      userName: user
    }
    this._loading= true;
    this._saveOtaAppEditApkSubscription = this._service.saveOtaApp('update', otaAppDetails, this.otaData._id).subscribe((res: any) => {
      this._loading= false;
      if (res['status']) {
        if (res['response']) {
          this._service.toasterService({ type: 'success', msg: res['response']['message'] });
          this._message = null;
          this._activeModal.close(true);
        }
        else {
          this.errorMessage = res['response']['message'] + ' - ' + res['response']['error'];
          // this._service.toasterService({ type: 'error', msg: res['response']['message'] });
          this._message = res['response']['message'];
        }
      }
      else {
        this.errorMessage = res['response']['message'] + ' - ' + res['response']['error'];
        // this._service.toasterService({ type: 'error', msg: res['response']['message'] });
        this._message = res['response']['message'];
      }
    })
  }

  private _formatBytes(bytes: number): string {
    const UNITS = ['Bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const factor = 1024;
    let index = 0;
    while (bytes >= factor) {
      bytes /= factor;
      index++;
    }
    return parseFloat(bytes.toFixed(2)) + "" + UNITS[index]
  }
  
  private _fileUpload(relativePath: any, img: any, recordId: any) {
    this._enableSubmit = false;
    this.fileLoader = true
    this._uploadOtaFileSubscription = this._service.uploadOtaFile(relativePath, img, recordId).subscribe((res: any) => {
      if (res['status']) {
        this.fileLoader = false;
        if (res['response']['sasUrl']) {
          this._sasUrl = res['response']['sasUrl'];
          this._fileExist = true;
          this._enableSubmit = true;
          this.otaForm.value.url = res['response']['sasUrl'];
          this.otaForm.patchValue({ url: this.otaForm.value.url });
          this._fileError = null;
          this.buttonText = 'Delete File'
        } else {
          this._fileError = null;
          this.fileLoader = false;
          this._fileExist = null;
          this.otaForm.value.url = null;
          this.fileURL = null;
          this.otaForm.value.url = null;
          this.fileInfo = null;
          this.buttonText = 'Upload File'
        }
      } else {
        this.fileLoader = false;
        this._fileExist = false;
        this._fileError = res['response']['error']
        this.fileURL = null;
        this.otaForm.value.url = null;
        this.fileInfo = null;
        this.buttonText = 'Upload File'
      }
    })
  }

}
